import { render } from "./NestedBadgeWrapper.vue?vue&type=template&id=2d0afc82&scoped=true"
import script from "./NestedBadgeWrapper.vue?vue&type=script&lang=js"
export * from "./NestedBadgeWrapper.vue?vue&type=script&lang=js"

import "./NestedBadgeWrapper.vue?vue&type=style&index=0&id=2d0afc82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0afc82"]])

export default __exports__